import React, { useState, useRef, useContext, useEffect } from "react";
import { Toast } from "primereact/toast";

// contexts
import { CartDataContext } from "../../contexts/CartContext";
import { HiOutlineTrash } from "react-icons/hi2";
import { Link } from "react-router-dom";
import { toFarsiNumber } from "../../helper/helper";
import Loading from "../shared/Loading";
import { getData, postData } from "../../services/API";
const CartItem = ({ cartProduct, order, setDeleteLoading }) => {
  const { cart, setCart, updateCart, loaded, err } =
    useContext(CartDataContext);
  const [price, setPrice] = useState(0);
  const [quantity, setQuantity] = useState(1);
  const [run, setRun] = useState(true);

  const toastErr = useRef(null);

  const deleteProductCart = (product) => {
    setDeleteLoading(true);

    postData(`/shop/cart/delete`, { cart_id: product.id })
      .then((res) => {
        // update cart
        getData("/shop/cart/index", {}, true)
          .then((res) => {
            setDeleteLoading(false);
            setCart(res.data);
          })
          .catch((err) => {
            setDeleteLoading(false);

            toastErr.current.show({
              severity: "error",
              summary: "خطا هنگام برقراری ارتباط با سرور",
              detail: "لطفا دوباره تلاش کنید کنید",
              life: 3500,
            });
          });
      })
      .catch((err) => {
        setDeleteLoading(false);
        toastErr.current.show({
          severity: "error",
          summary: "خطا هنگام برقراری ارتباط با سرور",
          detail: "لطفا دوباره تلاش کنید کنید",
          life: 3500,
        });
      });
  };

  const increaseQuantity = () => {
    if (
      quantity < cartProduct.info.qty &&
      quantity < cartProduct.info.buy_limit
    ) {
      setQuantity((prev) => prev + 1);
    }
  };

  const decreaseQuantity = () => {
    if (quantity > 1) {
      setQuantity((prev) => prev - 1);
    }
  };

  return (
    <>
      {!order && (
        <td className="min-w-[60px] max-w-[60px]">
          <div className="flex justify-center items-center">
            <button
              onClick={() => deleteProductCart(cartProduct)}
              className="min-w-[44px] h-11 flex items-center justify-center bg-gradient-to-tl from-red-600 to-red-300 rounded-full shadow-lg"
            >
              <HiOutlineTrash className="text-[22px] text-white" />
            </button>
          </div>
        </td>
      )}

      <td className="max-w-[300px]">
        <div className="flex flex-col items lg:flex-row justify-center lg:justify-normal items-center gap-3">
          <div className="w-[95px] h-[95px] flex justify-center items-center rounded-xl overflow-hidden">
            <img
              src={`https://api.myunibest.com/${cartProduct.image[0].image}`}
              className="transition-all duration-300"
              alt=""
            />
          </div>

          <Link
            to={`/shop/${cartProduct.info.slug}`}
            className="w-fit lg:w-[253px] text-gray-200"
          >
            {cartProduct.info.title}
          </Link>
        </div>
      </td>

      <td className="text-center align-middle">
        <span className="text-gray-200">
          {toFarsiNumber(Number(cartProduct.price))} تومان
        </span>
      </td>

      <td>
        <div className="w-9 h-9 bg-gray-600 bg-opacity-80 text-gray-200 rounded-lg flex items-center justify-center">
          {toFarsiNumber(quantity)}
        </div>
      </td>

      <td className="min-w-[80px] text-center align-middle">
        <span className="text-yellow-700">
          {toFarsiNumber(Number(cartProduct.price))} تومان
        </span>
      </td>
    </>
  );
};

export default CartItem;
